document.addEventListener("DOMContentLoaded", function () {
 
  function highlightParts(section, typeEle) {
                var cls = section.attr('class');
                var Ele = $(typeEle + ' .' + cls + ' span');
                if (Ele.length) {
 
                    Ele.addClass('product_includes_hover');
                }
                // console.log(section);
                section.find('span').addClass('product_includes_hover');
            }
 
            function unHighlightParts(section, typeEle) {
                section.find('span').removeClass('product_includes_hover');
                var cls = section.attr('class');
                var Ele = $(typeEle + ' .' + cls + ' span');
                if (Ele.length) {
                    Ele.removeClass('product_includes_hover');
                }
            }
            $('.texts ul li ').mouseover(function () {
                highlightParts($(this), '.images');
            });
 
            $('.texts ul li ').mouseout(function () {
                unHighlightParts($(this), '.images');
            });
            $('.images .col div').mouseover(function () {
                highlightParts($(this), '.texts');
            });
 
            $('.images .col div').mouseout(function () {
                unHighlightParts($(this), '.texts');
            });

   });

  window.onload = function (e){
    function countryDropdown(selector) {
      var Selected = $(selector);
      var Drop = $(selector + '-drop');
      var DropItem = Drop.find('li');
      Selected.click(function () {
        Selected.toggleClass('open');
        Drop.toggle();
      });
      Drop.find('li').click(function () {
        Selected.removeClass('open');
        Drop.hide();

        var item = $(this);
        console.log(item.html());
        console.log(item.text());
        Selected.html(item.text());
        window.location.href = item.attr('data-url');
      });
      DropItem.each(function () {
        var code = $(this).attr('data-code');
        if (code != undefined) {
          var countryCode = code.toLowerCase();
          $(this).find('i').addClass('flagstrap-' + countryCode);
        }
      });
    }
    $(document).on('click', function(event) {
      if (!$(event.target).closest('#country').length) {
        if (!$(event.target).closest('#country-drop').length) {
        var Selected = $('#country');
        var Drop = $( '#country-drop');
          Drop.hide();
        }
      }
    });
    countryDropdown('#country');    
  }



var acc = document.getElementsByClassName("collection__filter-link");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    console.log("Hi");
    this.classList.toggle("is-active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

$('.pagination__item.group[rel="next"]').click(function() {
  console.log(acc);
  for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    console.log("Hi");
    this.classList.toggle("is-active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
});